<template>
  <div>
    <b-card class="mt-2 mb-3">
    <b-media right-align vertical-align="center">
        <template v-slot:aside>
            <b-img v-bind:src="cart.Product.img_url" width="80" alt="placeholder"></b-img>
        </template>
        <b-row class="mt-1 mb-1 text-left">
            <b-col><h5>{{ cart.Product.name }}</h5></b-col>
        </b-row>
        <b-row cols="2" class="text-left">
            <b-col class="text-success">Price: ${{ cart.Product.price }}</b-col>
            <b-col><b-icon-box-seam/> Available Stock: {{ cart.Product.stock }}</b-col>
            <b-col cols="12">Qty: </b-col>
            <b-col cols="4">
                <ButtonPlusMinus :qty="cart.qty" :stock="cart.Product.stock" :IdProd="cart.Product.id"/>
            </b-col>
        </b-row>
    </b-media>
    <b-button size="sm" variant="danger" class="float-right" @click="deleteCart(cart.Product.id)"><b-icon-trash/> Remove</b-button>
    </b-card>
  </div>
</template>

<script>
import ButtonPlusMinus from './ButtonPlusMinus.vue'

export default {
  name: 'CartList',
  props: ['cart'],
  methods: {
    deleteCart (prodId) {
      console.log(prodId, '<<<< ID Cart-nya')
      this.$store.dispatch('delCartByIdProd', prodId)
    }
  },
  components: {
    ButtonPlusMinus
  }
}
</script>

<style>

</style>
